module.exports = __webpack_public_path__ + "img/Zuckerperlen.c7248238.svg";